<template>
<div class="page-wrapper page">
    <div class="page-grid-wrapper standardPage">

        <div class="page-grid-fix">
            <article class="grid-container columns-one tick article-login">
                <section class="section1">
                    <MembersNavigation />
                </section>

                <section class="section2">
                    <AuthUser />
                    <!-- <br /><br />
                    <router-link to="dashboard"><button class="submit"> <- go back </button></router-link> -->
                    <AuthUserForm />
                    <PasswordUpdate />
                </section>
            </article>
        </div>

    </div>
</div>
</template>

<script>
import AuthUser from "../components/AuthUser";
import AuthUserForm from "../components/AuthUserForm";
import PasswordUpdate from "../components/PasswordUpdate";
import MembersNavigation from "../components/MembersNavigation";

export default {
  name: "Dashboard",
  components: {
    AuthUser,
    AuthUserForm,
    PasswordUpdate,
    MembersNavigation
  },
   mounted() {
        // Emit to parent that this page is loaded and App.vue can hide loader
        this.$emit("route-data-ready");
    },
    watch: {
        '$route.name': function () {
            this.showRoute = this.$route.name;
        },
            /* $route(to, from) {
            this.reloadPage();
        }, */
        },
};
</script>
